import {
  useHMSStore,
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
  selectCameraStreamByPeerID,
  selectPeerAudioByID,
  selectConnectionQualityByPeerID
} from "@100mslive/react-sdk";
import { FaHandPaper, FaMicrophoneSlash } from "react-icons/fa";
import UserIcon from "./userIcon";

function Peer({ peer, size = "lg" }) {
  // Get the video track directly from the store

  // Get the audio track and check if it's muted
  const isModerator = peer.roleName.includes("moderator");
  const isHandRaised = peer.isHandRaised;

  const isPeerAudioEnabled = useHMSStore(selectIsPeerAudioEnabled(peer.id));
  const isPeerVideoEnabled = useHMSStore(selectIsPeerVideoEnabled(peer.id));
  // Get the video stream directly using the correct selector
  const videoTrack = useHMSStore(selectCameraStreamByPeerID(peer.id));
  const peerAudioLevel = useHMSStore(selectPeerAudioByID(peer.id));
  const networkQuality = useHMSStore(selectConnectionQualityByPeerID(peer.id));

  const getNetworkQualityColor = (quality) => {
    if (quality >= 3) return "bg-emerald-500";
    if (quality >= 2) return "bg-yellow-500";
    if (quality >= 1) return "bg-orange-500";
    return "bg-red-500";
  };

  return (
    <div className="p-2 relative flex flex-col items-center justify-center">
      <UserIcon
        src={peer.avatarUrl || "/default-avatar.png"}
        name={peer.name}
        variant={isModerator ? "moderator" : "default"}
        trackId={videoTrack?.id}
        isVideoEnabled={isPeerVideoEnabled && !!videoTrack}
        size={size}
        peer={peer}
      />
      {isHandRaised && (
        <FaHandPaper className="text-yellow-500 absolute w-7 h-7 top-16 right-0 peer-icon" />
      )}

      {/* Network Quality Indicator - now positioned absolutely */}
      <div className="absolute top-1 right-1 bg-gray-500/85 rounded-full p-1.5">
        <div className="flex items-end gap-[2px] h-3">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className={`w-[2px] rounded-sm transition-all duration-200 ${
                i < (networkQuality?.downlinkQuality || 0)
                  ? getNetworkQualityColor(networkQuality?.downlinkQuality)
                  : "bg-gray-600"
              }`}
              style={{
                height: `${40 + i * 20}%`
              }}
            />
          ))}
        </div>
      </div>

      <div className="mt-1 text-center">
        {/* <p className="text-white-100 text-xs font-medium truncate mt-2">{peer.roleName}</p> */}
        <div className="flex items-center justify-center">
          <span className="text-white-100 text-xs font-medium truncate mt-2">
            {peer.name} {peer.isLocal ? "(You)" : ""}
          </span>
          <div className="ml-1 mt-0 relative">
            {!isPeerAudioEnabled ? (
              <FaMicrophoneSlash className="text-red-500 !text-sm mt-2 peer-icon" size={12} />
            ) : (
              <div className="absolute flex items-center justify-center gap-1 h-2">
                <span className="flex items-start justify-center gap-1 h-2">
                  {[...Array(4)].map((_, i) => (
                    <span
                      key={i}
                      className={`w-1 rounded-full transition-all duration-200 ${
                        peerAudioLevel > i * 0.25 ? "bg-emerald-500 h-full" : "bg-gray-300 h-1/2"
                      }`}
                    />
                  ))}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Peer;
